import { render, staticRenderFns } from "./availability.vue?vue&type=template&id=ca8f0af6&scoped=true"
import script from "./availability.vue?vue&type=script&lang=js"
export * from "./availability.vue?vue&type=script&lang=js"
import style0 from "./availability.vue?vue&type=style&index=0&id=ca8f0af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8f0af6",
  null
  
)

export default component.exports